"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateMaterialIconsFontFaces = exports.createTheme = exports.createGlobalFont = exports.Theme = void 0;
var _styledComponents = require("styled-components");
var _lodash = require("lodash");
var _theme = require("./theme.types");
var _buttonColors = require("./buttonColors");
var _textButtonColors = require("./textButtonColors");
var _backgrounds = require("./backgrounds");
var _radii = require("./radii");
var _fontFamily = require("./fontFamily");
var _avatars = require("./avatars");
var _tableLayout = require("./tableLayout");
var _buttonSizes = require("./buttonSizes");
var _circularProgress = require("./circularProgress");
var _stepper = require("./stepper");
var _mediaQueries = require("./mediaQueries");
var _direction = require("./direction");
var _fonts = require("./fonts");
var _space = require("./space");
var _ref, _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Theme = {
  colors: _theme.Colors,
  buttonColors: {
    primary: {
      color: _theme.Colors.light,
      background: _theme.Colors.primary,
      borderColor: _theme.Colors.primary
    },
    purple: {
      color: _theme.Colors.light,
      background: _theme.Colors.purple,
      borderColor: _theme.Colors.purple
    },
    dark: {
      color: _theme.Colors.light,
      background: _theme.Colors.dark,
      borderColor: _theme.Colors.dark
    },
    maxBluePurple: {
      color: _theme.Colors.light,
      background: _theme.Colors.maxBluePurple,
      borderColor: _theme.Colors.maxBluePurple
    },
    independence: {
      color: _theme.Colors.light,
      background: _theme.Colors.independence,
      borderColor: _theme.Colors.independence
    },
    spanishGray: {
      color: _theme.Colors.light,
      background: _theme.Colors.spanishGray,
      borderColor: _theme.Colors.spanishGray
    },
    princetonOrange: {
      color: _theme.Colors.light,
      background: _theme.Colors.princetonOrange,
      borderColor: _theme.Colors.princetonOrange
    },
    silver: {
      color: _theme.Colors.light,
      background: _theme.Colors.silver,
      borderColor: _theme.Colors.silver
    },
    purpleNavy: {
      color: _theme.Colors.light,
      background: _theme.Colors.purpleNavy,
      borderColor: _theme.Colors.purpleNavy
    },
    green: {
      color: _theme.Colors.light,
      background: _theme.Colors.green,
      borderColor: _theme.Colors.green
    },
    lightRed: {
      color: _theme.Colors.light,
      background: _theme.Colors.lightRed,
      borderColor: _theme.Colors.lightRed
    },
    orange: {
      color: _theme.Colors.light,
      background: _theme.Colors.orange,
      borderColor: _theme.Colors.orange
    },
    red: {
      color: _theme.Colors.light,
      background: _theme.Colors.red,
      borderColor: _theme.Colors.red
    },
    light: {
      color: _theme.Colors.dark,
      background: _theme.Colors.light,
      borderColor: _theme.Colors.light
    },
    cultured: {
      color: _theme.Colors.dark,
      background: _theme.Colors.cultured,
      borderColor: _theme.Colors.cultured
    },
    platinum: {
      color: _theme.Colors.dark,
      background: _theme.Colors.platinum,
      borderColor: _theme.Colors.platinum
    },
    lavender: {
      color: _theme.Colors.dark,
      background: _theme.Colors.lavender,
      borderColor: _theme.Colors.lavender
    },
    darkCultured: {
      color: _theme.Colors.dark,
      background: _theme.Colors.darkCultured,
      borderColor: _theme.Colors.darkCultured
    },
    yellow: {
      color: _theme.Colors.dark,
      background: _theme.Colors.yellow,
      borderColor: _theme.Colors.yellow
    },
    darkSilver: {
      color: _theme.Colors.dark,
      background: _theme.Colors.darkSilver,
      borderColor: _theme.Colors.darkSilver
    }
  },
  textButtonColors: {
    primary: {
      color: _theme.Colors.primary
    },
    cultured: {
      color: _theme.Colors.cultured
    },
    dark: {
      color: _theme.Colors.dark
    },
    light: {
      color: _theme.Colors.light
    },
    platinum: {
      color: _theme.Colors.platinum
    },
    purple: {
      color: _theme.Colors.purple
    },
    maxBluePurple: {
      color: _theme.Colors.maxBluePurple
    },
    independence: {
      color: _theme.Colors.independence
    },
    spanishGray: {
      color: _theme.Colors.spanishGray
    },
    princetonOrange: {
      color: _theme.Colors.princetonOrange
    },
    darkCultured: {
      color: _theme.Colors.darkCultured
    },
    lavender: {
      color: _theme.Colors.lavender
    },
    yellow: {
      color: _theme.Colors.yellow
    },
    red: {
      color: _theme.Colors.red
    },
    orange: {
      color: _theme.Colors.orange
    },
    darkSilver: {
      color: _theme.Colors.darkSilver
    },
    purpleNavy: {
      color: _theme.Colors.purpleNavy
    },
    silver: {
      color: _theme.Colors.silver
    }
  },
  backgrounds: {
    cultured: {
      backgroundColor: _theme.Colors.cultured
    },
    dark: {
      backgroundColor: _theme.Colors.dark
    },
    light: {
      backgroundColor: _theme.Colors.light
    },
    maxBluePurple: {
      backgroundColor: _theme.Colors.maxBluePurple
    },
    platinum: {
      backgroundColor: _theme.Colors.platinum
    },
    primary: {
      backgroundColor: _theme.Colors.primary
    },
    purple: {
      backgroundColor: _theme.Colors.purple
    },
    independence: {
      backgroundColor: _theme.Colors.independence
    },
    spanishGray: {
      backgroundColor: _theme.Colors.spanishGray
    },
    princetonOrange: {
      backgroundColor: _theme.Colors.princetonOrange
    },
    darkCultured: {
      backgroundColor: _theme.Colors.darkCultured
    },
    lavender: {
      backgroundColor: _theme.Colors.lavender
    },
    yellow: {
      backgroundColor: _theme.Colors.yellow
    },
    red: {
      backgroundColor: _theme.Colors.red
    },
    purpleNavy: {
      backgroundColor: _theme.Colors.purpleNavy
    },
    silver: {
      backgroundColor: _theme.Colors.silver
    },
    darkSilver: {
      backgroundColor: _theme.Colors.darkSilver
    },
    orange: {
      backgroundColor: _theme.Colors.orange
    },
    green: {
      backgroundColor: _theme.Colors.green
    },
    lightRed: {
      backgroundColor: _theme.Colors.lightRed
    }
  },
  breakpoints: _mediaQueries.aliasBreakpoints,
  breakpointsInPx: _mediaQueries.breakpointsInPx,
  mediaQueries: {
    small: "@media screen and (max-width : ".concat(_mediaQueries.aliasBreakpoints.md, ")"),
    medium: "@media screen and (min-width : ".concat(_mediaQueries.aliasBreakpoints.md, ")"),
    large: "@media screen and (min-width : ".concat(_mediaQueries.aliasBreakpoints.lg, ")"),
    xlarge: "@media screen and (min-width : ".concat(_mediaQueries.aliasBreakpoints.xl, ")"),
    min: function min(value) {
      return "@media screen and (min-width : ".concat(value, "px)");
    },
    max: function max(value) {
      return "@media screen and (max-width : ".concat(value, "px)");
    }
  },
  borderRadii: _radii.radii,
  fontSizes: [10, 12, 14],
  fontSizesAliases: {
    button: 0.875,
    'small-t1': '0.5rem',
    'small-t2': '0.625rem',
    'small-t3': '0.75rem',
    'small-t4': '0.875rem',
    'small-t5': '1rem',
    'medium-t1': '1.125rem',
    'medium-t2': '1.25rem',
    'medium-t3': '1.375rem',
    'medium-t4': '1.5rem',
    'medium-t5': '1.625rem',
    'large-t1': '1.75rem',
    'large-t2': '1.875rem',
    'large-t3': '2rem',
    'large-t4': '2.125rem'
  },
  space: {
    margin: [],
    'margin-bottom': [10, 12, 14]
  },
  fontFamilies: {
    main: 'Montserrat'
  },
  avatarSizes: {
    small: {
      width: 33,
      height: 33,
      minWidth: 33,
      minHeight: 33
    },
    medium: {
      width: 55,
      height: 55,
      minWidth: 55,
      minHeight: 55
    },
    large: {
      width: 77,
      height: 77,
      minWidth: 77,
      minHeight: 77
    },
    xlarge: {
      width: 100,
      height: 100,
      minHeight: 100,
      minWidth: 100
    }
  },
  avatarShapes: {
    circle: {
      borderRadius: '50%'
    },
    square: {
      borderRadius: '10px'
    }
  },
  tableLayout: {
    fixed: {
      tableLayout: 'fixed'
    },
    auto: {
      tableLayout: 'auto'
    }
  },
  buttonSizes: {
    small: {
      padding: '0.5rem 2rem'
    },
    medium: {
      padding: '1.125rem 2rem'
    },
    large: {
      padding: '1.125rem 2rem'
    }
  },
  direction: (_ref = document.documentElement.dir) !== null && _ref !== void 0 ? _ref : 'ltr',
  circularProgressColors: {
    primary: {
      stroke: _theme.Colors.primary
    }
  },
  circularProgressSizes: {
    small: {
      '--size': '30',
      width: '30px',
      height: '30px',
      fontSize: '0.5rem',
      '--stroke-width': '3'
    },
    medium: {
      '--size': '40',
      width: '40px',
      height: '40px',
      fontSize: '0.75rem',
      '--stroke-width': '4'
    },
    large: {
      '--size': '50',
      width: '50px',
      height: '50px',
      fontSize: '0.75rem',
      '--stroke-width': '4'
    },
    xlarge: {
      '--size': '100',
      width: '100px',
      height: '100px',
      fontSize: '1rem',
      '--stroke-width': '4'
    }
  },
  stepperIconSizes: {
    small: {
      width: '1.406rem',
      height: '1.406rem'
    }
  },
  stepperIconColors: {
    primary: {
      background: _theme.Colors.primary,
      borderColor: _theme.Colors.primary
    },
    princetonOrange: {
      background: _theme.Colors.princetonOrange,
      borderColor: _theme.Colors.princetonOrange
    },
    spanishGray: {
      background: _theme.Colors.spanishGray,
      borderColor: _theme.Colors.spanishGray
    }
  }
};
exports.Theme = Theme;
var createTheme = function createTheme(options) {
  var theme = {};
  theme.colors = _theme.Colors;
  theme.borderRadii = _radii.radii;
  theme.tableLayout = _tableLayout.tableLayouts;
  theme.circularProgressSizes = _circularProgress.circularProgressSizes;
  theme.stepperIconSizes = _stepper.stepperIconSizes;
  theme.mediaQueries = _mediaQueries.mediaQueries;
  theme.breakpoints = _mediaQueries.aliasBreakpoints;
  theme.breakpointsInPx = _mediaQueries.breakpointsInPx;
  theme.fontSizes = _fonts.fontSizes;
  theme.fontSizesAliases = _fonts.fontSizesAliases;
  theme.space = _space.space;
  theme = (0, _lodash.merge)({}, theme, options);
  theme.fontFamilies = (0, _fontFamily.getFontFamily)(theme);
  theme.buttonSizes = (0, _buttonSizes.getButtonSizes)(theme);
  theme.avatarShapes = (0, _avatars.getAvatarShapes)(theme);
  theme.avatarSizes = (0, _avatars.getAvatarSizes)(theme);
  theme.buttonColors = (0, _buttonColors.getButtonColors)(theme);
  theme.textButtonColors = (0, _textButtonColors.getTextButtonColors)(theme);
  theme.backgrounds = (0, _backgrounds.getBackgrounds)(theme);
  theme.circularProgressColors = (0, _circularProgress.getCircularProgressColors)(theme);
  theme.stepperIconColors = (0, _stepper.getStepperIconsColors)(theme);
  theme.direction = (0, _direction.getThemeDirection)();
  theme = (0, _lodash.merge)({}, theme, options);
  return theme;
};
exports.createTheme = createTheme;
var generateMaterialIconsFontFaces = function generateMaterialIconsFontFaces(material_icons) {
  var css_string = '';
  var familyBaseName = 'Material Icons';
  var getTypeName = function getTypeName(type) {
    var _material_icons$mappe, _material_icons;
    return (_material_icons$mappe = (_material_icons = material_icons[type]) === null || _material_icons === void 0 ? void 0 : _material_icons.mapped_name) !== null && _material_icons$mappe !== void 0 ? _material_icons$mappe : " ".concat(type);
  };
  Object.keys(material_icons).forEach(function (type) {
    var _material_icons2;
    var src = (_material_icons2 = material_icons[type]) === null || _material_icons2 === void 0 ? void 0 : _material_icons2.src;
    var typeFamilyName = "".concat(familyBaseName).concat(getTypeName(type).length > 0 ? " ".concat(getTypeName(type)) : '');
    var typeClassName = ".material-icons".concat("".concat(getTypeName(type).length > 0 ? '-' : '').concat(getTypeName(type).toLocaleLowerCase()));
    var typeCss = "\n\t\t@font-face {\n\t\t  font-family: \"".concat(typeFamilyName, "\";\n\t\t  font-style: normal;\n\t\t  font-weight: 400;\n\t\t  src: url(").concat(src, ") ;\n\t\t}\n\t\t").concat(typeClassName, "{\n\t\t  font-family: \"").concat(typeFamilyName, "\";\n\t\t  font-weight: normal;\n\t\t  font-style: normal;\n\t\t  // font-size: 24px;\n\t\t  line-height: 1;\n\t\t  letter-spacing: normal;\n\t\t  text-transform: none;\n\t\t  display: inline-block;\n\t\t  white-space: nowrap;\n\t\t  word-wrap: normal;\n\t\t  direction: ltr;\n\t\t  -webkit-font-feature-settings: \"liga\";\n\t\t  -webkit-font-smoothing: antialiased;\n\t\t}\n\t  ");
    css_string += typeCss;
  });
  return (0, _styledComponents.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t\t", "\n\t"])), css_string);
};
exports.generateMaterialIconsFontFaces = generateMaterialIconsFontFaces;
var createGlobalFont = function createGlobalFont(font, fontWeightsSrc) {
  var weights = fontWeightsSrc.fonts[font];
  var styles = '';
  Object.keys(weights).forEach(function (weight, index) {
    styles += "@font-face {\n\t    font-family : '".concat(font, "';\n      \tsrc: url(").concat(Object.values(weights)[index], ");\n\t    font-weight : ").concat(weight, ";\n\t  }");
  });
  return (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\t", "\n\t"])), styles);
};
exports.createGlobalFont = createGlobalFont;